import { styled } from '@ori-ui/mui';

import { bubbleHeight } from '../../constants';

const topNavHeightStyle = 'var(--top-nav-height, 0)';

export const BasketBubbleWrapper = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  width: theme.spacing(64),
  marginTop: 10,
  pointerEvents: 'none',
  position: 'fixed',
  top: 0,
  right: 15,
  transform: `translate(0, ${topNavHeightStyle})`,
  transition: `transform var(--top-nav-height-animation), 0.3s ease-in-out`,
  zIndex: 10000,

  [theme.breakpoints.up('sm')]: {
    right: 30,
  },

  '& *': {
    boxSizing: 'border-box',
  },
}));

export const AnimationWrapper = styled('div')<{
  ownerState: { state: string };
}>(({ ownerState }) => ({
  transition: 'opacity 750ms',
  opacity: 0,

  ...(ownerState.state === 'entered' && {
    opacity: 1,
  }),

  ...(ownerState.state === 'exiting' && {
    opacity: 0,
    transition: 'margin-top 300ms 950ms, opacity 1250ms',
    marginTop: -(bubbleHeight + 10),
  }),
}));
